const { useState, useEffect } = React;

const useWPAjaxMutation = (ajaxUrl, params) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const saveData = async (saveData) => {
    setIsError(false);
    setError(null);
    setIsLoading(true);

    const formData = new FormData();

    Object.keys(params).map((key) => formData.append(key, params[key]));
    Object.keys(saveData).map((key) => formData.append(key, saveData[key]));

    try {
      const request = await fetch(`${ajaxUrl}`, {
        method: "POST",
        body: formData,
      });
      window.formData = formData;
      const response = await request.json();
      setData(response?.data);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setError(error.message);
      setIsLoading(false);
    }

    // try {
    //   const model = new wp.api.models.Settings({
    //     [key]: prepareData(data, type, true),
    //   });
    //   model.save().then((response) => {
    //     setData(prepareData(response[key], type));
    //     setIsLoading(false);
    //   });
    // } catch (error) {
    //   setIsError(true);
    //   setError(error?.message);
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    setIsLoading(true);
    wp.api.loadPromise.then(() => {
      const settings = new wp.api.models.Settings();
      settings.fetch().then((response) => {
        setData(prepareData(response[key], type));
        setIsLoading(false);
      });
    });
  }, []);

  const prepareData = (data, type, forSave = false) => {
    let newData = data;

    if (forSave && type === "object") {
      const { isLoaded, ...restData } = data;
      newData = restData;
    }
    if (type === "object") {
      try {
        newData = forSave ? JSON.stringify(data) : JSON.parse(data);
      } catch (error) {
        setError(error?.message);
        setIsError(true);
      }
    }
    return newData;
  };

  return { data, saveData, isLoading, isError, error };
};

export default useWPAjaxMutation;
